import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20manga%20comic%20landscape%20background%20with%20abstract%20ink%20brush%20strokes%2C%20floating%20open%20comic%20books%20and%20glowing%20paper%20pages%2C%20warm%20amber%20coral%20and%20cream%20color%20palette%2C%20cinematic%20soft%20light%2C%20editorial%20illustration%20for%20a%20comic%20ranking%20website&width=1800&height=900&seq=home-hero&orientation=landscape"
          alt="漫天堂漫画人气榜与热度排行背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400"></i>
          实时更新人气榜 · 热度排行 · 高分推荐
        </span>
        <h1 className="max-w-3xl font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          告别选择困难，一页掌握当下最值得追的漫画
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          漫天堂聚合人气榜与热度排行，实时更新编辑推荐与高分漫画。必看清单帮你快速锁定口碑神作与热门新番，从今往后不再纠结看什么。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/blood"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            浏览人气榜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
          >
            了解漫天堂
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { label: "收录作品", value: "860+" },
            { label: "实时榜单", value: "6 大分类" },
            { label: "日均更新", value: "120+" },
            { label: "编辑推荐", value: "精选" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/20 bg-background-950/25 px-3 py-4 backdrop-blur"
            >
              <dt className="text-xs text-background-100/80">{s.label}</dt>
              <dd className="mt-1 font-heading text-xl font-extrabold text-accent-400 md:text-2xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}